import { RootState } from '../store';

export const selectIsSessionModalOpen = (state: RootState) =>
  state.session.isModalOpen;

export const selectIsSessionModalOpenedForAdd = (state: RootState) =>
  state.session.isModalOpenedForAdd;

export const selectSelectedSession = (state: RootState) =>
  state.session.selectedSession;

export const selectValidationErrors = (state: RootState) =>
  state.session.validationErrors;

export const selectFormHasErrors = (state: RootState) => {
  const errors = state.session.validationErrors;
  return Object.keys(errors).some((key) => errors[key].length > 0);
};
